<template>
  <div class="h-3 w-3">
    <i v-if="pnl > 0" v-html="$icons.play_green"></i>
    <i v-else-if="pnl < 0" v-html="$icons.play_red"></i>
    <i v-else class="w-3 h-3 rounded-full bg-gray-500"></i>
  </div>
</template>

<script>
export default {
  props: {
    pnl: {
      type: Number,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped></style>
